const styles = (theme) => ({
  label: {
    fontWeight: 700,
    position: 'static',
    color: theme.palette.text.secondary,
  },
});

export default styles;
